// TOP-LEVEL IMPORTS
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Caption from 'components/text/Caption';
import Subtitle from 'components/text/Subtitle';
import Lottie from 'react-lottie';
import * as animationData from 'lib/media/empty_box.json';
import PropTypes from 'prop-types';

// STYLED-COMPONENTS
// ==============================
const Container = styled.div`
  display: flex;
  width: 1220px;
  max-width: 100%;
  min-height: ${p => p.containerStyle.minHeight}px;
  margin: 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding-bottom: ${p => p.containerStyle.paddingBottom}px;
`;

const Content = styled.div`
  display: block;
  text-align: center;
`;

const ActionsContainer = styled.div`
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BottomContainer = styled.div`
  margin-top: ${p => p.bottomContainerStyle.marginTop}px;
`;

// EXPORTED COMPONENT
// ==============================
class EmptyState extends PureComponent {
  render() {
    return (
      <Container containerStyle={this.props.containerStyle}>
        <Content>
          {this.props.media ? (
            this.props.media
          ) : (
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: this.props.animationData ? this.props.animationData : animationData,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice',
                },
              }}
              height={this.props.animationHeight}
              width={this.props.animationWidth}
            />
          )}
          <BottomContainer bottomContainerStyle={this.props.bottomContainerStyle}>
            <Subtitle style={this.props.titleStyle}>{this.props.title}</Subtitle>
            <Caption style={this.props.subTitleStyle}>{this.props.subtitle}</Caption>
            {this.props.action && <ActionsContainer>{this.props.action}</ActionsContainer>}
          </BottomContainer>
        </Content>
      </Container>
    );
  }
}

EmptyState.defaultProps = {
  title: 'Nothing to See Here...',
  subtitle: 'Hmm....',
  titleStyle: {
    color: '#fff',
  },
  subTitleStyle: {
    color: '#fff',
  },
  containerStyle: {
    minHeight: 370,
    paddingBottom: 200,
  },
  bottomContainerStyle: {
    marginTop: 25,
  },
  animationHeight: 235,
  animationWidth: 205,
  media: null,
};

EmptyState.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  titleStyle: PropTypes.object,
  subTitleStyle: PropTypes.object,
  containerStyle: PropTypes.shape({
    minHeight: PropTypes.number,
    paddingBottom: PropTypes.number,
  }),
  bottomContainerStyle: PropTypes.shape({
    marginTop: PropTypes.number,
  }),
  animationWidth: PropTypes.number,
  animationHeight: PropTypes.number,
  media: PropTypes.object,
};

// EXPORT
// ==============================
export default EmptyState;



// WEBPACK FOOTER //
// ./src/components/common/EmptyState/index.js